export default "__VITE_ASSET__05f4710d__"